export default __webpack_public_path__ + "static/media/sec3.fcdd84f8.svg";